import { useState } from 'react';
// Reddux
import { useSelector } from 'react-redux';
// Hooks
import { useScrollToTop } from '../../hooks/useScrollToTop';
// Components
import Container from '../Container';
// Utils
import { removeElement } from '../../utils/removeElement';
// Icons
import { IoMdOptions } from 'react-icons/io';
import { TbChevronUp } from 'react-icons/tb';
import { IoMdClose } from 'react-icons/io';
// Styles
import './FiltersInterestingLinks.css';
// Translate
import { useTranslation } from 'react-i18next';

const FiltersInterestingLinks = ({ selected, setSelected }) => {
	const { t } = useTranslation();
	const { handleScrollToTop } = useScrollToTop();

	const { interestingLinks } = useSelector((state) => state.interestingLinks);
	const programsList = interestingLinks.map((objeto) => objeto.program);
	const programs = [...new Set(programsList)];

	// Variables para visualización de filtros
	const [isOpenSource, setIsOpenSource] = useState(true);
	const [activeFilter, setActiveFilter] = useState(false);

	const handleSelectSource = (source) => {
		handleScrollToTop(0);
		if (selected.includes(source)) {
			setSelected(selected.filter((value) => value !== source));
		} else {
			setSelected([...selected, source]);
		}
	};

	const handleClearSources = () => {
		handleScrollToTop(0);
		setSelected([]);
	};

	const handleRemoveSource = (source) => {
		handleScrollToTop(0);
		setSelected(removeElement(selected, source));
	};

	return (
		<>
			<button className='filtersBarIconNews' onClick={() => setActiveFilter(true)} >
				<b>{t('Filters')}</b>
				<IoMdOptions className='optionsIcon' />
			</button>

			<section
				className={
					activeFilter
						? 'sectionFilterNews activeFilterNews'
						: 'sectionFilterNews'
				}
			>
				<div
					onClick={() => setActiveFilter(false)}
					className={
						activeFilter
							? 'filterBarBackgroundNews activeFilterNews'
							: 'filterBarBackgroundNews'
					}
				></div>
				<div className='filtersBarNews'>
					<Container className='filtersBarMainNews'>
						<div>
							<IoMdOptions className='optionsIcon' />
							<h2>
								{t('Filters')}
							</h2>
						</div>
						<button onClick={() => setActiveFilter(false)}>
							<IoMdClose className='optionsIconClose' />
						</button>
					</Container>

					{selected?.length > 0 && (
						<Container className='filtersBarSectionNews'>
							<div className='filtersBarSection__main'>
								<h3>
									{t('Filters')}
								</h3>
								<button onClick={handleClearSources}>
									{t('Remove all filters')}
								</button>
							</div>
							<div className='filtersBarSectionFilter__content'>
								{selected?.length > 0 &&
									selected?.map((source, i) => (
										<button key={i} onClick={() => handleRemoveSource(source)}>
											{t(source)} <IoMdClose />
										</button>
									))}
							</div>
						</Container>
					)}

					<Container className='filtersBarSectionNews'>
						<div className='filtersBarSection__main' onClick={() => setIsOpenSource(!isOpenSource)}>
							<h3>{t('Sources')}</h3>

							<button>
								<TbChevronUp className={isOpenSource ? '' : 'iconActive'} />
							</button>
						</div>
						{isOpenSource && (
							<div className='filtersBarSection__content fixed'>
								{programs?.map((program, i) => {
									return (
										<button
											key={i}
											className={selected.includes(program) ? 'selected' : ''}
											onClick={() => handleSelectSource(program)}
										>
											{t(program)}
										</button>
									);
								})}
							</div>
						)}
					</Container>
				</div>
			</section>
		</>
	);
};

export default FiltersInterestingLinks;
